import { AuthDto, ClientType, ServiceProviderMap } from '@uploadcam/common';
import { GetCredentialInteractor } from './get-credential.interactor';
import { RefreshCredentialInteractor } from './refresh-credential.interactor';

export class GetAuthDtoInteractor {
  constructor(
    private readonly clientIds: ServiceProviderMap<string>,
    private readonly getCredential: GetCredentialInteractor,
    private readonly refreshCredential: RefreshCredentialInteractor,
  ) {}

  public async execute(): Promise<AuthDto> {
    let credential = this.getCredential.execute();

    if (credential.isExpired) {
      credential = await this.refreshCredential.execute(credential);
    }

    return {
      provider: credential.provider,
      clientType: ClientType.Web,
      clientId: this.clientIds[credential.provider],
      accessToken: credential.accessToken,
      metadata: credential.metadata,
    };
  }
}
